import notifications from './notifications';
import capAlerts from './capAlerts';

export default {
  notifications,
  capAlerts,
};



// WEBPACK FOOTER //
// ./src/store/modules/index.js